// extracted by mini-css-extract-plugin
export default {"Main":"ConcessionOrganizationUsers_Main__LMUWM","Roles":"ConcessionOrganizationUsers_Roles__FhgCj"};